export default __webpack_public_path__ + "static/media/strcutureforming.6495f81a.jpg";